var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav-side h-100",class:_vm.visibilityMode()},[_c('div'),_c('perfect-scrollbar',{attrs:{"options":{suppressScrollX: true}}},[_c('ul',{staticClass:"navbar-nav mx-3 mt-3 mt-lg-2"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }